<script lang="ts">
	
	import { createEventDispatcher } from 'svelte';
	import SocDemoCell from './FilterTable/SocDemoCell.svelte';
	import InterestsCell from './FilterTable/InterestsCell.svelte';
	import PlatformCell from './FilterTable/PlatformCell.svelte';
	import DeleteCell from './FilterTable/DeleteCell.svelte';
	import moment from 'moment';
	import type { Segment, SegmentsDashboard } from 'Segments';
	import SimpleTable from '../../SimpleTable.svelte';
	import IncomeCell from './FilterTable/IncomeCell.svelte';
	import EducationCell from "./FilterTable/EducationCell.svelte";
	import AbcdeCell from "./FilterTable/AbcdeCell.svelte";
	import { namesStore } from '../../../stores/segmentList';
	import Card from '../../Card.svelte';
	import DownloadSegmentsJson from '../../DownloadSegmentsJson.svelte';
	import DownloadSegmentsCsv from '../../DownloadSegmentsCsv.svelte';

  	export let data = [];
  	export let qdata = [];
  	export let mixdata = [];
  	let mixdataNames = [];

	
	
// Get the segments from data tables and then make a list of it to pass to the store
	let names = [];
	for (let key in data) {
    if (data.hasOwnProperty(key)) {
        names.push(data[key].name); 
    }
};

	namesStore.set(names);

	$: {
		if (mixdata) {
			mixdata.forEach((segment) => {
				const combined = JSON.parse(segment.combined);
				combined.forEach((it: string) => {
					mixdataNames.push(it);
				});
			});
		}
	}

	let dispatch = createEventDispatcher();
	function dispatchDeleted() {
		dispatch('dispatchRefresh');
	}

	const columns = [
		{
			key: 'name',
			title: 'Name',
			value: (v: Segment) => v.name,
			class: 'segment-name',
			headerClass: 'segment-name',
			searchValue: (v: Segment) => v.name,
			renderValue: (v: Segment) =>
				'<span style="max-width: 8vw; white-space: normal">' + v.name + '</span>',
			sortable: true
		},
		{
			key: 'socdemo',
			title: 'Soc Demo',
			value: (v: Segment) => v.socDemo.certainty,
			class: 'socdemo',
			headerClass: 'socdemo',
			renderComponent: {
				component: SocDemoCell
			}
		},
		{
			key: 'interests',
			title: 'Interests',
			value: (v: Segment) => v.interests,
			class: 'interests',
			headerClass: 'interests',
			renderComponent: {
				component: InterestsCell
			}
		},
		{
			key: 'income',
			title: 'Income',
			value: (v: Segment) => v.income,
			class: 'income',
			headerClass: 'income',
			renderComponent: {
				component: IncomeCell
			}
		},
		{
			key: "education",
			title: "Education",
			value: (v: Segment) => v.education,
			class: "education",
			headerClass: "education",
			renderComponent: {
				component: EducationCell
			}
		},
		{
			key: "abcde",
			title: "ABCDE segments",
			value: (v: Segment) => v.abcde,
			class: "abcde",
			headerClass: "abcde",
			renderComponent: {
				component: AbcdeCell
			}
		},
		{
			key: 'created',
			title: 'Created at',
			value: (v: Segment) => v.firstRun,
			renderValue: (v: Segment) => moment(v.firstRun).format('MM/DD/YYYY'),
			class: 'first-run',
			headerClass: 'first-run',
			sortable: true
		},

		{
			key: 'day-last-refreshed',
			title: 'Last updated at',
			value: (v: Segment) => v.id,
			renderValue: (v: Segment) => {
				
				let result = qdata.filter((r) => r.id === v.id);
				
			    if (result.length > 0) {
					if (result[0].platformUploadCompletedAt == null) {
						return "Not available."
					}
					else {
						return moment(result[0].platformUploadCompletedAt).format('MM/DD/YYYY HH:mm');
					}
				}
				else {
				  return "Not available.";
				};

			},
			class: 'platform_upload_completed_at',
			headerClass: 'platform_upload_completed_at',
			sortable: true
		},

		{
			key: 'platform',
			title: 'Platform import',
			value: (v: Segment) => v.id,
			class: 'platform',
			headerClass: 'platform',
			renderComponent: {
				component: PlatformCell,
				props: {
					mixArray: mixdataNames
				}
			}
		},
		{
			key: 'delete',
			title: 'Actions',
			value: (v: Segment) => v.id,
			class: 'delete',
			headerClass: 'delete',
			renderComponent: {
				component: DeleteCell,
				props: {
					mixArray: mixdataNames
				}
			}
		}
	];
	
</script>

<Card>
	<div class="row">
		<DownloadSegmentsCsv />
	</div>
</Card>

<SimpleTable rows={data} {columns} sortBy= "created" sortOrder={-1} on:refresh={dispatchDeleted} />
